const DEST_DATA: [string, { photo: string; from: string; to: string }][] = [
  ['paris',     { photo: 'photo-1502602898657-3e91760cbb34', from: '#e879a0', to: '#a855f7' }],
  ['london',    { photo: 'photo-1513635269975-59663e0ac1ad', from: '#334155', to: '#0f172a' }],
  ['new york',  { photo: 'photo-1496442226666-8d4d0e62e6e9', from: '#f59e0b', to: '#ef4444' }],
  ['lisboa',    { photo: 'photo-1555881400-74d7acaacd8b',   from: '#14b8a6', to: '#6366f1' }],
  ['lisbon',    { photo: 'photo-1555881400-74d7acaacd8b',   from: '#14b8a6', to: '#6366f1' }],
  ['madrid',    { photo: 'photo-1543785734-4b6e564642f8',   from: '#f97316', to: '#dc2626' }],
  ['barcelona', { photo: 'photo-1539037116277-4db20889f2d4', from: '#fbbf24', to: '#f97316' }],
  ['rome',      { photo: 'photo-1552832230-c0197dd311b5',   from: '#fb923c', to: '#dc2626' }],
  ['tokyo',     { photo: 'photo-1540959733332-eab4deabeeaf', from: '#f43f5e', to: '#a855f7' }],
  ['dubai',     { photo: 'photo-1512453979798-5ea266f8880c', from: '#fcd34d', to: '#f59e0b' }],
  ['amsterdam', { photo: 'photo-1534351590666-13e3e96b5017', from: '#22d3ee', to: '#3b82f6' }],
  ['berlin',    { photo: 'photo-1528360983277-13d401cdc186', from: '#64748b', to: '#1e293b' }],
  ['prague',    { photo: 'photo-1541849546-216549ae216d',   from: '#8b5cf6', to: '#6d28d9' }],
  ['vienna',    { photo: 'photo-1516550136977-53af2c88b4a8', from: '#10b981', to: '#0d9488' }],
  ['bali',      { photo: 'photo-1537996194471-e657df975ab4', from: '#34d399', to: '#059669' }],
  ['florence',  { photo: 'photo-1541370976299-4d24be33d3b7', from: '#fb7185', to: '#f97316' }],
  ['athens',    { photo: 'photo-1555993539-1732b0258235',   from: '#f59e0b', to: '#d97706' }],
  ['istanbul',  { photo: 'photo-1524231757912-21f4fe3a7200', from: '#ef4444', to: '#7c3aed' }],
];

export function getDest(destination: string) {
  const lower = destination.toLowerCase();
  const match = DEST_DATA.find(([k]) => lower.includes(k));
  if (match) return match[1];
  return { photo: '', from: '#14b8a6', to: '#1e3a5f' };
}

export function photoUrl(id: string, w = 600) {
  const dpr = typeof window !== 'undefined' ? Math.min(Math.ceil(window.devicePixelRatio || 1), 3) : 2;
  return `https://images.unsplash.com/${id}?w=${w * dpr}&q=80&fit=crop&crop=entropy&auto=format`;
}
